<template>
    <div style="text-align: center;">
        <h4>พิมพ์รายการภาษี {{fileType}}</h4>
        <br/>
        <div class="row form-group">
            <label class="col-sm-5 text-right">ประเภท</label>
            <div class="col-sm-6">
                <b-form-select :options="print_type"
                               v-model="print.type">
                </b-form-select>
            </div>
        </div>
        <div class="row form-group">
            <label class="col-sm-5 text-right">เลือกช่วงที่ต้องการพิมพ์</label>
            <div class="col-sm-6">
                <b-form-select :options="print_date"
                               v-model="print.range">
                </b-form-select>
            </div>
        </div>
        <div class="row form-group" v-if="print.range == 1">
            <label class="col-sm-5 text-right">พิมพ์รายงาน/วัน</label>
            <div class="col-sm-6">
                <date-picker v-model="print.date"
                             :lang="lang"
                             range
                             placeholder="วันที่ต้องการพิมพ์"
                             class="w-100"
                             :format="changeFormat" confirm>
                </date-picker>
            </div>
        </div>
        <div class="row form-group" v-if="print.range == 2">
            <label class="col-sm-5 text-right">พิมพ์รายงาน/เดือน</label>
            <div class="col-sm-6">
                <date-picker v-model="print.month"
                             type="month"
                             :lang="lang"
                             format="MM/YYYY"
                             placeholder="เดือนที่ต้องการพิมพ์"
                             confirm>
                </date-picker>
            </div>
        </div>
        <div class="row form-group" v-if="print.range == 3">
            <label class="col-sm-5 text-right">พิมพ์รายงาน/ปี</label>
            <div class="col-sm-6">
                <date-picker v-model="print.year"
                             type="year"
                             :lang="lang"
                             placeholder="ปีที่ต้องการพิมพ์"
                             format="YYYY" confirm>
                </date-picker>
            </div>
        </div>

        <button type="button"
                class="btn btn-primary"
                @click="submitTax"
        >พิมพ์
        </button>
        &nbsp;&nbsp;
        <button
            type="button"
            class="btn btn-outline-secondary"
            @click="cancelTax">ยกเลิก
        </button>
    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import moment from 'moment';

export default {
    name: "print-tax",
    components: {
        DatePicker
    },
    props: {
        fileType: {
            type: String,
            default: 'PDF'
        }
    },
    data() {
        return {
            print: {
                date: [],
                month: "",
                year: "",
                range: null,
                type: 'all'
            },
            print_date: [
                {value: null, text: "ช่วง วัน - เดือน - ปี"},
                {value: 1, text: "พิมพ์วัน"},
                {value: 2, text: "พิมพ์เดือน"},
                {value: 3, text: "พิมพ์ปี"},
            ],
            print_type: [
                {value: 'all', text: "ทั้งหมด"},
                {value: 'v', text: "เฉพาะ V"},
                {value: 's', text: "เฉพาะ S"},
            ],
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
        }
    },
    methods: {
        submitTax() {
            let start_date = "";
            let end_date = "";
            let month = "";
            let year = "";
            let range = this.print.range;
            if (!this.print.range) {
                alert("กรุณาเลือกช่วงวันที่ต้องการพิมพ์ภาษี");

            } else {
                if (this.print.range == 1 && this.print.date.length > 0 && this.print.date[0]) {
                    start_date = moment(this.print.date[0]).format("YYYY-MM-DD");
                    end_date = moment(this.print.date[1]).format("YYYY-MM-DD");
                }
                if (this.print.range == 2 && this.print.month) {
                    month = moment(this.print.month).format("YYYY-MM-DD")
                }
                if (this.print.range == 3 && this.print.year) {
                    year = moment(this.print.year).format("YYYY-MM-DD")
                }
                let data = {
                    start_date,
                    end_date,
                    month,
                    year,
                    range,
                    type: this.print.type
                };
                this.$emit('submit', data);
                this.print = {
                    date: [],
                    month: "",
                    year: "",
                    range: null,
                    type: 'all'
                }
            }
        },
        cancelTax() {
            this.$emit('submit', false);
            this.print = {
                date: [],
                month: "",
                year: "",
                range: null,
                type: 'all'
            }
        }
    }
}
</script>

<style scoped>

</style>
